import { APIHelper, ToastifyHelper, ArrayHelper, StringHelper } from './';
import i18next from 'i18next';
import { Store } from '../../store';
import {
    changeSearch,
    limparFiltros,
    changeAcervosFiltrados,
} from '../../store/ducks/pesquisa';
import {VinculosAPI} from "../http-requests";

const ConsultaHelper = () => {
    return {
        ordenarConsulta(argumento, consulta, direction) {
            let isNumeric = false;
            if (argumento === 'cod_tipo_obra' || argumento === 'cod_acervo')
                isNumeric = true;

            return consulta?.sort(
                ArrayHelper.sortByProperty(argumento, direction, isNumeric),
            );
        },
        acessarLinkAcessoRestrito(codAcervo, seqParagrafo) {
            ToastifyHelper.info(i18next.t('AguardeBuscandoLink'));
            let authData =
                Store.getState().authPersist.user || Store.getState().auth.user;
            VinculosAPI.acessarLinkAcessoRestrito(
                codAcervo,
                seqParagrafo,
                authData.login,
            )
                .then(response => {
                    if (response.data.pearson) {
                        localStorage.setItem('pearsonData', response.data.data);
                        window.open(
                            window.location.origin + '/pearson',
                            '_blank',
                        );
                    } else {
                        window.open(response.data, '_blank');
                    }
                })
                .catch(error => APIHelper.tratarErro(error));
        },
        acessarLinkAcessoRestritoPDF(codAcervo, seqParagrafo) {
            const link = {};
            const authData =
                Store.getState().authPersist.user || Store.getState().auth.user;
            VinculosAPI.acessarLinkAcessoRestrito(
                codAcervo,
                seqParagrafo,
                authData.login,
            )
                .then(response => {
                    if (!response.data.pearson) {
                        link['descricao'] = i18next.t('AcessoRestrito');
                        link['url_link'] = response.data;
                    }
                })
                .catch(error => APIHelper.tratarErro(error));
            if (link && link.url_link !== null) {
                return link;
            }
        },
        acessarVinculo(codAcervo, seqParagrafo, url) {
            VinculosAPI.gravarEstatisticaAcessoVinculo(
                codAcervo,
                seqParagrafo,
                url,
            ).catch(error => {
                return;
            });
            window.open(url, '_blank');
        },
        limparConsulta(callback) {
            Store.dispatch(changeSearch(false));
            Store.dispatch(limparFiltros());
            Store.dispatch(changeAcervosFiltrados([]));
            if (callback !== undefined) {
                callback();
            }
        },
        acessarLinkAbnt(normaId) {
            ToastifyHelper.info(i18next.t('AguardeBuscandoLink'));

            VinculosAPI.acessarLinkAbnt(normaId)
                .then(response => {
                    window.open(response.data, '_blank');
                })
                .catch(error => APIHelper.tratarErro(error));
        },
        acessarNormaTarget(normaId) {
            ToastifyHelper.info(i18next.t('AguardeBuscandoLink'));

            VinculosAPI.acessarNormaTarget(normaId)
                .then(response => {
                    window.open(response.data, '_blank');
                })
                .catch(error => APIHelper.tratarErro(error));
        },
        validateSearchFields (form, isPaginatedSearch) {
            const commonSearch = [
                'pesquisa_geral',
                'e_books',
                'autoridades',
                'acessibilidade',
                'multimeios'
            ];
            const otherSearch = [
                'arquivo',
                'pesquisa_avancada',
                'atos_normativos',
                'jurisprudencia',
            ];
    
            if (form.search_tab) {
                if (commonSearch.includes(form.search_tab)) {
                    if (
                        StringHelper.isBlank(form.termo_pesquisa) ||
                        StringHelper.isBlank(form.coluna_um)
                    ) {
                        return false;
                    }
                } else if (otherSearch.includes(form.search_tab)) {
                    if (
                        StringHelper.isBlank(form.termo_pesquisa) ||
                        StringHelper.isBlank(form.coluna_um)
                    ) {
                        return false;
                    }
    
                    if (form.termo_pesquisa_dois) {
                        if (
                            StringHelper.isBlank(form.termo_pesquisa_dois) ||
                            form.condicao_um === undefined ||
                            form.condicao_um === '-1'
                        ) {
                            return false;
                        }
                    }
    
                    if (form.termo_pesquisa_tres) {
                        if (
                            StringHelper.isBlank(form.termo_pesquisa_tres) ||
                            form.condicao_dois === undefined ||
                            form.condicao_dois === '-1'
                        ) {
                            return false;
                        }
                    }
    
                    if (
                        form.search_tab === 'pesquisa_avancada' &&
                        StringHelper.isBlank(form.tipo_termos)
                    ) {
                        return false;
                    }
                } else if (form.search_tab === 'novas_aquisicoes') {
                    if (StringHelper.isBlank(form.coluna_um)) return false;
                    if (
                        form.coluna_um !== 'TODOS' &&
                        StringHelper.isBlank(form.termo_pesquisa)
                    )
                        return false;
                } else if (form.search_tab === 'plano_ensino') {
                    if (form.tipo_termos === undefined) return false;
    
                    if (
                        form.termo_pesquisa === undefined ||
                        StringHelper.isBlank(form.termo_pesquisa)
                    )
                        return false;
                    if (
                        form.coluna_um === undefined ||
                        StringHelper.isBlank(form.coluna_um)
                    )
                        return false;
    
                    if (form.termo_pesquisa_dois !== undefined) {
                        if (StringHelper.isBlank(form.termo_pesquisa_dois))
                            return false;
                        if (
                            form.coluna_dois === undefined ||
                            StringHelper.isBlank(form.coluna_dois)
                        )
                            return false;
                    }
    
                    if (form.termo_pesquisa_tres !== undefined) {
                        if (StringHelper.isBlank(form.termo_pesquisa_tres))
                            return false;
                        if (
                            form.coluna_tres === undefined ||
                            StringHelper.isBlank(form.coluna_tres)
                        )
                            return false;
                    }
                }
    
                if (isPaginatedSearch) {
                    if (
                        !form.page ||
                        Number.isNaN(Number(form.page)) ||
                        !form.perPage ||
                        Number.isNaN(Number(form.perPage))
                        // ||
                        // StringHelper.isBlank(form.orderBy) ||
                        // StringHelper.isBlank(form.direction)
                    )
                        return false;
                }
            } else {
                return false;
            }
    
            return true;
        },
    };
};

export default ConsultaHelper();
